<template>
  <div class="vz-modal">
    <transition name="modal">
      <div class="vz-modal-mask">
        <div class="vz-modal-wrapper">
          <div class="vz-modal-container">
            <div class="vz-modal-header">
              <slot name="header">
                <div class="vz-modal-title-close">
                  <i
                    class="ic-x vz-modal-ranking-x"
                    @click="$emit('close')"
                  ></i>
                </div>

                <div class="vz-modal-title">
                  <div class="vz-modal-title-text">
                    <slot name="title"></slot>
                  </div>
                  <div class="vz-modal-title-icon">
                    <slot name="icon"></slot>
                  </div>
                </div>
              </slot>
            </div>

            <div class="vz-modal-body">
              <template>
                <slot name="component"></slot>
              </template>
            </div>

            <div class="vz-modal-modal-footer">
              <slot name="footer"> </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="vz-t-fade">
      <div class="vz-modal-loading" v-if="loading">
        <i class="ic-loader vz-spin" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'modal-ranking',
  data() {
    return {
      showModal: false,
      loading: false,
      componentType: ''
    };
  },
  created() {
    const componentPath = this.component;
    if (this.component) {
      return import(`@/${componentPath}.vue`).then((res) => {
        this.componentType = res.default;
      });
    }
  },
  props: {
    rankingData: {
      type: Object,
      default: () => {}
    },
    dataModal: {
      type: Object,
      default: () => {}
    },
    open: {
      type: Boolean,
      default: false
    },
    component: {
      type: String,
      default: ''
    }
  }
};
</script>

































































































































<style theme="light-theater" scoped>
.vz-modal-mask {
  position: fixed;
  z-index: var(--modal-overlay-index);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
  transition: opacity 0.3s ease;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.4);
}

.vz-modal-title-close {
  display: flex;
  justify-content: flex-end;
}
.vz-modal-title {
  border-bottom: 1px solid #424242;
  color: var(--my-course-title-color);
  display: flex;
  height: 60px;
}

.vz-modal-title-text {
  justify-content: flex-start;
  width: 50%;
  display: flex;
  font-size: 0.7em;
  text-transform: uppercase;
  padding: 5px 5px 5px 30px;
}

.vz-modal-title-icon {
  justify-content: flex-end;
  width: 50%;
  display: flex;
  font-size: 2.5em;
  padding: 10px 25px 5px 5px;
}

.vz-modal-ranking-x {
  background: #ffffff;
  color: #0c0c0c;
  padding: 2px;
  border-radius: 10px;
  cursor: pointer;
}

.vz-modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.vz-modal-container {
  width: 50%;
  margin: 0 auto;
  padding: 0 0 5px 0;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  height: 35em;
}

.vz-modal-header {
  background: #f9f9f9;
}

.vz-modal-container .modal-header .vz-modal-ranking-x {
  background: #ffffff;
  color: #0c0c0c;
  padding: 2px;
  border-radius: 10px;
  cursor: pointer;
}
.vz-modal-body {
  margin: 20px 0;
  /*display: flex;*/
  /*flex-wrap: wrap;*/
  padding: 10px;
}

.vz-modal-enter .vz-modal-container,
.vz-modal-leave-active .vz-modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.vz-modal-loading {
  text-align: center;
  margin: 0 auto;
  position: relative;
}

@media screen and (max-width: 1024px) {
  .vz-modal-container[data-v-fd0c1c6e] {
    width: 70%;
    margin: 0 auto;
    padding: 0 0 5px 0;
    border-radius: 2px;
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    height: 35em;
  }
}

@media (max-width: 600px) {
  .vz-modal-container {
    width: 95%;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 0 5px 0;
    border-radius: 2px;
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    height: 35em;
  }
  .vz-modal-title-text {
    width: 100%;
    display: flex;
    font-size: 0.5em;
  }
}
</style>
